<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.ProcessPopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="ProcessPopup"
      class="process-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <van-field
        v-model="form.craftName"
        label="工艺名称"
        name="工艺名称"
        placeholder="请输入工艺名称"
        :rules="rules.craftName"
      />
      <div v-for="(item,key) in form.processingProcessInfo" :key="item.id" class="process-item">
        <van-field
          v-model="item.processName"
          label="工序名称"
          name="工序名称"
          placeholder="请输入工序名称"
        />
        <wh-staff v-model="item.staffName" lable="操作人" :disable="true" />
        <div class="wh-flex-start img">
          <div>操作图片</div>
          <wh-upload v-model="item.photo" :max-count="3" />
        </div>
        <div class="del-btn">
          <van-icon name="delete" color="#FF4444" size="30" @click="delprocess(key)" />
        </div>
      </div>
      <div class="process-add">
        <van-button class="btn" native-type="button" @click="addProcess">
          添加工序
        </van-button>
      </div>
    </van-form>
  </wh-popup>
</template>
<script>
import api from '@/api'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import WhStaff from '@/components/public/WhStaff/WhStaff'
import { formPopup } from '@/utils/mixins/formPopup'
import { img2String, deepClone } from '@/utils/tool'
import WhUpload from '@/components/public/WhUpload/WhUpload'
export default {
  components: { WhPopup, WhStaff, WhUpload },
  mixins: [formPopup],
  data() {
    return {
      form: {
        craftName: '',
        id: undefined,
        processingProcessInfo: []
      },
      rules: {
        craftName: [{ required: true, message: '请输入工艺名称' }]
      }
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增工序' : '编辑工序'
    }
  },
  methods: {
    img2String,
    deepClone,
    submitForm() {
      const flag = this.form.processingProcessInfo.some(item => {
        return !item.processName
      })
      if (flag) {
        this.$toast('工序不完整')
      } else {
        const params = this.deepClone(this.form)
        params.processingProcessInfo.map(i => {
          i.photo = this.img2String(i.photo)
        })
        if (this.form.id) {
          api.updateProcessing(params).then(res => {
            this.submitFormSuccess()
            this.$toast('编辑加工成功')
            this.hidePopup()
          })
        } else {
          this.form.id = undefined
          api.createProcessing(params).then(res => {
            this.submitFormSuccess()
            this.$toast('新增加工成功')
            this.hidePopup()
          })
        }
      }
    },
    delprocess(i) {
      this.$dialog.confirm({
        title: '是否删除?'
      })
        .then(() => {
          this.form.processingProcessInfo.splice(i, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    addProcess() {
      this.form.processingProcessInfo.push({
        id: undefined,
        processName: '',
        staffName: '',
        photo: []
      })
    },
    open() {
      if (this.formType === 'create') {
        this.formDataInit(this.form)
      } else {
        this.formDataInit(this.form, this.initFormData)
      }
    }
  }

}
</script>
<style lang="less" scoped>
.process-popup{
  padding: 10px 16px;
  .process-item{
    border: 1px solid #eee;
    margin-bottom: 6px;
    padding: 4px 12px 4px 4px;
    border-radius: 16px;
    background-color: #fff;
    .del-btn{
      width: 100%;
      text-align: right;
    }
    .img{
      padding: 10px 0 10px 16px;
      >div{
        height: 88px;
        font-size: 14px;
        color: #646566;
        margin-right: 10px;
      }
    }
    .process-area{
      margin-bottom: 10px;
    }
    .process-btn{
      width: 50%;
      background-color: #fff;
      color: #666;
    }
  }
  .process-add{
    margin-top: 10px;
    text-align: center;
    margin-bottom: 20px;
    .btn{
      width: 200px;
      background-color: #20caa0;
      color: #fff;
      border-radius: 12px;
    }
  }
}
</style>
